import { Languages } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { IDIOMAS_SUPORTADOS, trocarIdioma } from '@/lib/i18n';

export function LanguageSwitcher({ compact = false }: { compact?: boolean }) {
  const { i18n } = useTranslation();

  if (compact) {
    return (
      <Button
        variant="ghost"
        size="sm"
        title="Trocar idioma"
        onClick={() => {
          const next = i18n.language === 'pt-BR' ? 'en-US' : 'pt-BR';
          trocarIdioma(next);
        }}
      >
        <Languages className="mr-1 h-4 w-4" />
        {i18n.language === 'pt-BR' ? 'PT' : 'EN'}
      </Button>
    );
  }

  return (
    <Select value={i18n.language} onValueChange={trocarIdioma}>
      <SelectTrigger className="w-40">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {IDIOMAS_SUPORTADOS.map((i) => (
          <SelectItem key={i.code} value={i.code}>
            {i.flag} {i.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
